(ns hai.account.routes
  (:require [hai.ui.components :as c]
            [hai.web-app.layout :as layout]
            [hai.web-app.routing :as routing]))

(defn page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "Account 🚧"]]
   [:div "Coming soon!"]])

(defn routes []
  [["/account" {:name :account
                ::routing/window-title "Account"
                :view page}]])